import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let has_admin = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.permissions.has_admin',
  })

  return useMemo(
    () =>
      rdata
        .filter(tab => (tab.needs_admin ? has_admin : true))
        .map(({ needs_admin, ...tab }) => tab),
    [rdata, has_admin]
  )
}
